import roundToGivenDecimals from './roundToGivenDecimals';
import getHashrateValueWithUnit from './getHashrateValueWithUnit';

const displayHashrateValue = (value: number): { unit: string, value: number } => {
  // Coerce non-finite input (e.g. parseFloat('') → NaN from a missing hashrate)
  // to 0 so the table/tiles show "0 h/s" instead of "NaN h/s".
  const safe = Number.isFinite(value) ? value : 0;
  const units = getHashrateValueWithUnit(safe);

  return {
    value: roundToGivenDecimals(safe / units.coefficient, 2),
    // eslint-disable-next-line sort-keys
    unit: units.unit,
  };
};

export default displayHashrateValue;